import React from 'react';
import { Link } from 'react-router-dom';
import cx from 'classnames';

import { ReactComponent as SkLogo } from 'assets/sk-logo-2.svg';
import { LocalizedMessage } from 'components';

import classes from './Footer.module.scss';

const currentYear = new Date().getFullYear();

const items = ['copyright', 'docs.policy', 'docs.dataProcessingConsent', 'docs.offer', 'contacts',
  'contacts.email', 'contacts.tel', 'contacts.name', 'contacts.address', 'contacts.inn', 'contacts.ogrn',
  'contacts.okvjed', 'contacts.vidydejatelnosti', 'costofservices'];

const Footer = () => (
  <LocalizedMessage id={items.map(item => `pages.footer.${item}`)}>
    {(copyright, policy, dataProcessingConsent, offer, contacts, email, tel, name, address, inn, ogrn, okvjed,
        vidydejatelnosti, costofservices) => (
        <footer className={classes.Footer} id="company">
          <div className={classes.FooterLeft}>
            <div>
              <h2 className={classes.Title}>
                {`© ${currentYear} ${copyright}`}
              </h2>
              <p><Link to="/docs/policy" className={classes.Link}>{policy}</Link></p>
              <p><Link to="/docs/dpc" className={classes.Link}>{dataProcessingConsent}</Link></p>
              <p><Link to="/docs/offer" className={classes.Link}>{offer}</Link></p>
            </div>
            <a className={classes.SkLink} href="https://sk.ru/" target="_blank" rel="noopener noreferrer">
              <SkLogo className={classes.SkLogo} />
            </a>
          </div>
          <div className={classes.Contacts}>
            <h2 className={cx(
              classes.Title,
              classes.TitleLazur,
            )}
            >
              {contacts}
              :
            </h2>
            <p><a href={`mailto: ${email}`} className={classes.Link}>{email}</a></p>
            <p><a href={`tel: ${tel}`} className={classes.Link}>{tel}</a></p>
            <p>{name}</p>
            <p>ИНН {inn}</p>
            <p>ОГРН {ogrn}</p>
            <p>ОКВЭД {okvjed}</p>
            <p>Виды деятельности – {vidydejatelnosti}</p>
            <p className={classes.Address}>{address}</p>
            <p>{costofservices}</p>
            <h3>Технологический стек</h3>
<p>Backend: Java, Python, RestAPI, GraphQL, PostgreSQL</p>
<p>Frontend: ReactJS, Tilda, Python (plotly, dash)</p>
<p>Сетевые технологии: TCP/IP, DNS</p>
<p>Требуемая ОС: браузерное приложение позволяет использовать любую операционную систему с браузером на базе chrome</p>
            <p>Айзек (Aizek) - реестровая запись&nbsp;
№<a href="https://reestr.digital.gov.ru/reestr/1834300/?sphrase_id=8009591" className={classes.Link}>19378</a>&nbsp;
от 04.10.2023</p>
          </div>
        </footer>
    )}
  </LocalizedMessage>
);

export default Footer;
